import {
  CmsApiCtaHeroBlockData,
  CmsApiCtaHeroBlockLayout,
} from 'modules/cms/api/types/CmsApiCtaHero';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsCtaHeroBlock } from './CmsCtaHeroBlock';

export const CmsCtaHeroBlockMapping: CmsBlockMapping<CmsApiCtaHeroBlockData> = {
  invariant: [
    {
      prop: 'text',
      msg: 'Text data required for call to action',
    },
    {
      prop: 'image',
      msg: 'Image data required for call to action',
    },
  ],
  width: (data) => {
    if (data.layout === CmsApiCtaHeroBlockLayout.COMPACT)
      return CmsBlockWidth.NARROW;
    if (data.layout === CmsApiCtaHeroBlockLayout.STANDARD)
      return CmsBlockWidth.FULL;
    return CmsBlockWidth.FULL;
  },
  Component: CmsCtaHeroBlock,
  AmpComponent: CmsAmpHeroBlock,
};
